import { siteStats, testimonials } from '@/mocks/site';

export default function StatsSection() {
  return (
    <section id="trust" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {siteStats.map((stat) => (
            <div key={stat.label} className="flex flex-col gap-2 rounded-lg border border-background-300/60 bg-background-50 p-5 md:p-6">
              <div className="flex items-baseline gap-1.5">
                <span className="font-heading text-3xl md:text-4xl font-black text-primary-600">{stat.value}</span>
                <span className="text-sm font-label text-foreground-500">{stat.unit}</span>
              </div>
              <span className="font-heading text-base font-semibold text-foreground-950">{stat.label}</span>
              <span className="text-xs leading-relaxed text-foreground-600">{stat.desc}</span>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-chat-quote-line" aria-hidden="true" />
              用户口碑
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              读者的反馈，是我们调整栏目结构的依据
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              我们定期收集读者对频道划分、专题归类与导航路径的建议，并据此优化栏目设置与内容分布。
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((item, index) => (
              <blockquote
                key={item.name + item.role}
                className={`flex flex-col gap-4 rounded-lg border border-background-300/60 p-5 md:p-6 ${
                  index === 0 ? 'bg-accent-50' : 'bg-background-50'
                }`}
              >
                <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true" />
                <p className="text-sm leading-relaxed text-foreground-700">{item.text}</p>
                <footer className="mt-auto flex items-center gap-3 pt-3 border-t border-background-300/60">
                  <span className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-heading font-bold">
                    {item.name}
                  </span>
                  <span className="text-xs font-label text-foreground-500">{item.role}</span>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}